

window.FAQ = window.FAQ || {};

window.FAQ.toggleItem = function(item, closeOthers = false) {
  if (!item || !item.classList.contains('faq-item')) return;
  
  const container = item.closest('.faq-items') || item.closest('.faq-category-section');
  
  if (closeOthers && container) {
    container.querySelectorAll('.faq-item.active').forEach(activeItem => {
      if (activeItem !== item) {
        activeItem.classList.remove('active');
        const btn = activeItem.querySelector('.faq-question');
        const ans = activeItem.querySelector('.faq-answer');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (ans) ans.setAttribute('aria-hidden', 'true');
      }
    });
  }
  
  item.classList.toggle('active');
  
  const button = item.querySelector('.faq-question');
  const answer = item.querySelector('.faq-answer');
  const isOpen = item.classList.contains('active');
  
  if (button) button.setAttribute('aria-expanded', isOpen);
  if (answer) answer.setAttribute('aria-hidden', !isOpen);
};

window.FAQ.switchCategory = function(categoryId, sectionElement = null) {
  const section = sectionElement || document.querySelector('[data-faq-section]');
  if (!section) return;
  
  section.querySelectorAll('.faq-category-button').forEach(button => {
    const isActive = button.getAttribute('data-category-id') === categoryId;
    button.classList.toggle('active', isActive);
    button.setAttribute('aria-pressed', isActive);
  });
  
  section.querySelectorAll('.faq-category-section').forEach(categorySection => {
    const isActive = categorySection.getAttribute('data-category-id') === categoryId;
    categorySection.classList.toggle('active', isActive);
    categorySection.setAttribute('aria-hidden', !isActive);
  });
  
  const activeCategory = section.querySelector(`.faq-category-section[data-category-id="${categoryId}"]`);
  if (activeCategory) {
    activeCategory.querySelectorAll('.faq-item.active').forEach(item => {
      item.classList.remove('active');
      const btn = item.querySelector('.faq-question');
      const ans = item.querySelector('.faq-answer');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (ans) ans.setAttribute('aria-hidden', 'true');
    });
  }
};

// Event Delegation - funktioniert auch nach DOM Änderungen
document.addEventListener('click', function(e) {
  // FAQ Question Click
  if (e.target.closest('.faq-question')) {
    e.preventDefault();
    const button = e.target.closest('.faq-question');
    const item = button.closest('.faq-item');
    if (item) {
      const container = item.closest('[data-accordion="true"]');
      const closeOthers = container !== null;
      window.FAQ.toggleItem(item, closeOthers);
    }
  }
  
  // Category Button Click
  if (e.target.closest('.faq-category-button')) {
    e.preventDefault();
    const button = e.target.closest('.faq-category-button');
    const categoryId = button.getAttribute('data-category-id');
    const section = button.closest('[data-faq-section]');
    if (categoryId && section) {
      window.FAQ.switchCategory(categoryId, section);
    }
  }
});

// Keyboard Navigation
document.addEventListener('keydown', function(e) {
  if (e.target.closest('.faq-question') && (e.key === 'Enter' || e.key === ' ')) {
    e.preventDefault();
    e.target.closest('.faq-question').click();
  }
});

function initializeFAQ() {
  // Set Accessibility Attributes
  document.querySelectorAll('.faq-question').forEach(button => {
    const item = button.closest('.faq-item');
    const answer = button.parentElement.querySelector('.faq-answer');
    const isActive = item && item.classList.contains('active');
    
    button.setAttribute('aria-expanded', isActive);
    button.setAttribute('role', 'button');
    
    if (answer) {
      answer.setAttribute('aria-hidden', !isActive);
      answer.setAttribute('role', 'region');
    }
  });
  
  document.querySelectorAll('.faq-category-button').forEach(button => {
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-pressed', button.classList.contains('active'));
  });
  
  // Initialize first category if none active
  document.querySelectorAll('[data-faq-section]').forEach(section => {
    const hasActiveCategory = section.querySelector('.faq-category-button.active');
    if (!hasActiveCategory) {
      const firstCategory = section.querySelector('.faq-category-button');
      if (firstCategory) {
        const categoryId = firstCategory.getAttribute('data-category-id');
        if (categoryId) {
          window.FAQ.switchCategory(categoryId, section);
        }
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', initializeFAQ);



// Legacy Support
function toggleFAQItem(item, closeOthers = false) {
  window.FAQ.toggleItem(item, closeOthers);
}

function switchCategory(categoryId, sectionElement = null) {
  window.FAQ.switchCategory(categoryId, sectionElement);
}